import { Attributes } from '@leverege/ui-attributes';
import { Types } from "../constants/index.js";
export default {
  id: 'fota.ItemCreateHook.HandlePercentFirmwareRelease',
  objectType: Types.firmwareRelease,
  hook: data => {
    const percentDevicesToGetFirmwareApplication = Attributes.get('percentDevicesToGetFirmwareApplication', Types.firmwareRelease, data);
    const deviceGroupsAttr = Attributes.getAttribute('deviceGroups', Types.firmwareRelease);
    const deviceGroups = deviceGroupsAttr.get(data);
    if (Array.isArray(deviceGroups) && percentDevicesToGetFirmwareApplication != null) {
      const toReturn = deviceGroupsAttr.set(data, deviceGroups.map(dg => ({
        ...dg,
        percentDevicesToGetFirmwareApplication
      })));
      delete toReturn.percentDevicesToGetFirmwareApplication;
      return toReturn;
    }
    return data;
  }
};